import React from 'react';

const stats = [
  {
    value: '6',
    label: 'Módulos integrados',
    desc: 'Comunicação, desenho, música, rotinas, jogos e progresso em um só app.',
  },
  {
    value: '5',
    label: 'Instituições parceiras',
    desc: 'Pesquisa e apoio institucional por trás do desenvolvimento do Conectar.',
  },
  {
    value: 'WCAG',
    label: 'Acessibilidade no design',
    desc: 'Contraste, tipografia e navegação pensados para todos os públicos.',
  },
];

const StatsSection = () => {
  return (
    <section className="relative py-20 md:py-28 bg-background">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-10 md:mb-12">
          Construído com propósito
        </h2>
        <div className="grid md:grid-cols-3 gap-6 text-left">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-2xl bg-primary/[0.05] dark:bg-primary/[0.1] px-6 py-6"
            >
              <span className="block text-4xl md:text-5xl font-bold text-primary-ink dark:text-primary-tint mb-3">
                {stat.value}
              </span>
              <h3 className="font-semibold text-foreground text-lg md:text-xl">{stat.label}</h3>
              <p className="text-base text-muted-foreground mt-1">{stat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
